const ALLOWED_ROUTES = {
    "Demandeur": ["Tableau de bord", "Tickets", "Details du ticket", "Interventions", "Details de l'intervention","Profil", "Aide et support"],
    "Collaborateur": ["Tableau de bord", "Profil", "Tickets", "Details du ticket", "Interventions", "Details de l'intervention", "Équipements", "Details de l'équipement", "Aide et support"],
    "Prestataire": ["Tableau de bord","Profil", "Interventions", "Details de l'intervention", "Tickets", "Details du ticket", "Équipements", "Details de l'équipement", "Aide et support"],
};

const PUBLIC_ROUTES = ["Se connecter", "Mot de passe oublié", "Réinitialisation du mot de passe"];

export {ALLOWED_ROUTES, PUBLIC_ROUTES};